import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { SET_APPLICATIONS, SET_CLIENTS, SET_CONSENT_STATUS, SET_CONSENT_OBTAINED_DATE, SET_CURRENT_FILTERS, SET_FLOWS, REMOVE_APPLICATION, MARK_VERIFICATION_FOR_IMPORT, SET_CLIENT_APPLICATIONS } from "./applications-list-mutations";
import { addClientProfile, createAdditionalApplication, createApp, getClientsByAgent, getFilogixSignedURL, getSchema, notifyImport, putConsent, starClient, deleteApplication, importApplications, verifyImportApplications, getClientApplicationsInfo } from "../../api/applications-list-api";
import Err from "../../../../../../routes/error";
import { applicationsSchema, clientsSchema } from "./applications-list-schema";
import { normalize } from "normalizr";
import { showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/utils/amplitude";
import { putS3Data } from "@Shared/utils/ajax";
export const IMPORT_CLIENTS = "IMPORT_CLIENTS";
export const LOAD_FLOWS = "LOAD_FLOWS";
export const CREATE_APPLICATION = "CREATE_APPLICATION";
export const LOAD_CLIENTS = "LOAD_CLIENTS";
export const LOAD_APPLICATIONS_WITH_INFO_FOR_CLIENT = "LOAD_APPLICATIONS_WITH_INFO_FOR_CLIENT";
export const ADD_TO_BOARD = "ADD_TO_BOARD";
export const LOAD_CLIENT_APPLICATIONS = "LOAD_CLIENT_APPLICATIONS";
export const CREATE_ADDITIONAL_APPLICATION = "CREATE_ADDITIONAL_APPLICATION";
export const CHANGE_CONSENT_STATUS = "CHANGE_CONSENT_STATUS";
export const CHANGE_STARRED_CLIENT = "CHANGE_STARRED_CLIENT";
export const COPY_APPLICATION = "COPY_APPLICATION";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const IMPORT_FILOGIX_APPLICATIONS = "IMPORT_FILOGIX_APPLICATIONS";
export const VERIFY_IMPORT_EMAIL = "VERIFY_IMPORT_EMAIL";
export default {
  [IMPORT_CLIENTS]: async (context, {
    fileName,
    file
  }) => {
    fileName = _replaceAllInstanceProperty(fileName).call(fileName, " ", "-");
    try {
      const {
        url,
        documentId,
        contentType
      } = await getFilogixSignedURL(fileName);
      await putS3Data(file, url, contentType);
      await notifyImport(fileName, documentId);
    } catch (e) {
      Err.handle(e, {}, "failedToImportClients");
    }
  },
  [CREATE_APPLICATION]: async (context, data) => {
    try {
      const {
        clientUsername,
        applicationId
      } = await createApp(data);
      Amplitude.logEvent("Add Client Modal - manual application created", {
        client: data.email,
        applicationId
      });
      return {
        clientUsername,
        applicationId
      };
    } catch (e) {
      Err.handle(e, context);
      throw e;
    }
  },
  [CREATE_ADDITIONAL_APPLICATION]: async (context, {
    data,
    clientUsername,
    agentUsername,
    clientProfileId
  }) => {
    try {
      const {
        applicationId
      } = await createAdditionalApplication(data, clientUsername, agentUsername, clientProfileId);
      Amplitude.logEvent("Add Client Modal - manual application created", {
        client: data.email
      });
      return {
        applicationId,
        agentUsername,
        clientUsername,
        clientProfileId
      };
    } catch (e) {
      Err.handle(e, {}, "failedToCreateAdditionalApplication");
      throw e;
    }
  },
  [COPY_APPLICATION]: async (context, {
    data,
    clientUsername,
    agentUsername,
    clientProfileId
  }) => {
    try {
      const {
        applicationId
      } = await createAdditionalApplication(data, clientUsername, agentUsername, clientProfileId);
      Amplitude.logEvent("Applications - application copied", {
        client: data.email
      });
      return {
        applicationId,
        agentUsername,
        clientUsername,
        clientProfileId
      };
    } catch (e) {
      Err.handle(e, {}, "failedToCopyApplication");
      throw e;
    }
  },
  [LOAD_FLOWS]: async context => {
    const {
      metadata: {
        "flow-selection": flows
      }
    } = await getSchema();
    context.commit(SET_FLOWS, flows);
  },
  [LOAD_CLIENTS]: async (context, {
    agentUsername,
    offset,
    limit,
    orderBy,
    orderType,
    searchString,
    board,
    read,
    status,
    partial
  }) => {
    try {
      context.commit(SET_CURRENT_FILTERS, {
        orderBy,
        orderType,
        searchString,
        board,
        read,
        status
      });
      const params = _objectSpread(_objectSpread({
        agentUsername,
        offset: offset || 0,
        limit: limit || 20
      }, context.state.clientsTableFilters), {}, {
        partial: context.state.clientsTableFilters.searchString ? false : partial
      });
      const {
        clients,
        total,
        applicationCount
      } = await getClientsByAgent(params);
      const hasClients = Boolean(clients.length);
      const {
        result,
        entities
      } = hasClients ? normalize(_mapInstanceProperty(clients).call(clients, c => _objectSpread(_objectSpread({}, c), {}, {
        fullyLoaded: !params.partial
      })), [clientsSchema]) : {
        result: [],
        entities: {
          clients: {},
          applications: {}
        }
      };
      context.commit(SET_CLIENTS, {
        clients: {
          allIds: result,
          byId: entities.clients
        },
        agentUsername,
        total: hasClients ? total : offset > 0 ? context.state.clients.allIds.length : 0,
        // On the last call this can be empty if the previous one happens to return the last user
        add: offset > 0,
        applicationCount
      });
      context.commit(SET_APPLICATIONS, {
        applications: {
          byId: entities.applications
        }
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadClients");
    }
  },
  [LOAD_APPLICATIONS_WITH_INFO_FOR_CLIENT]: async (context, {
    clientUsername,
    agentUsername
  }) => {
    try {
      const applications = await getClientApplicationsInfo(clientUsername, agentUsername);
      const {
        entities
      } = normalize(applications, [applicationsSchema]);
      context.commit(SET_CLIENT_APPLICATIONS, {
        clientUsername,
        applications,
        applicationsById: entities.applications
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadApplications");
    }
  },
  [ADD_TO_BOARD]: async (context, {
    clientDetails,
    boardId
  }) => {
    try {
      if (clientDetails.username) {
        clientDetails.clientUsername = clientDetails.username;
        delete clientDetails["username"];
      }
      const {
        clientProfileId
      } = await addClientProfile(clientDetails, boardId);
      clientDetails.clientProfileId = clientProfileId;
      Amplitude.updateCount("CLIENT_PROFILE_CREATED");
      Amplitude.logEvent("Board - client created");
      Amplitude.updateCount("linked applications");
      Amplitude.logEvent("Applications - added application to board", {
        data: {
          clientProfileId,
          clientUsername: clientDetails.clientUsername,
          boardId
        }
      });
      if (clientDetails.email) {
        Amplitude.logEvent("Board - added email to client", {
          page: "clients-applications",
          clientProfileId
        });
      }
      showToast("success", "clientProfileMoved");
      window.location = `#/board/${boardId}/profile/${clientProfileId}`;
    } catch (e) {
      Err.handle(e, {}, "The owner of this client profile is not set as a collaborator on the board you are trying to move to. Add them as a collaborator, and try again.");
    }
  },
  [CHANGE_CONSENT_STATUS]: async (context, {
    status,
    clientUsername,
    applicationId,
    date
  }) => {
    const currentStatus = status === "obtained" ? "not-obtained" : "obtained";
    try {
      context.commit(SET_CONSENT_STATUS, {
        status,
        applicationId
      });
      context.commit(SET_CONSENT_OBTAINED_DATE, {
        date,
        applicationId
      });
      await putConsent(status, clientUsername, applicationId, date);
    } catch (e) {
      context.commit(SET_CONSENT_STATUS, {
        status: currentStatus,
        applicationId
      });
      Err.handle(e, {}, "failedToChangeConsentStatus");
    }
  },
  [CHANGE_STARRED_CLIENT]: async (context, {
    clientUsername
  }) => {
    try {
      await starClient(clientUsername);
    } catch (e) {
      Err.handle(e, {}, "failedToChangeStarredStatus");
    }
  },
  [DELETE_APPLICATION]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      await deleteApplication(clientUsername, applicationId);
      context.commit(REMOVE_APPLICATION, {
        clientUsername,
        applicationId
      });
    } catch (e) {
      Err.handle(e, {}, "failedToDeleteApplication");
    }
  },
  [IMPORT_FILOGIX_APPLICATIONS]: async (context, {
    expertDealId,
    startDate,
    endDate,
    statusList
  }) => {
    try {
      const {
        emailFromExpert,
        shouldVerify
      } = await importApplications(expertDealId, startDate, endDate, statusList);
      if (shouldVerify) {
        context.commit(MARK_VERIFICATION_FOR_IMPORT, {
          emailFromExpert,
          shouldVerify
        });
      }
      return {
        shouldVerify
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [VERIFY_IMPORT_EMAIL]: async (context, {
    code,
    expertDealId
  }) => {
    try {
      await verifyImportApplications(code, expertDealId);
      context.commit(MARK_VERIFICATION_FOR_IMPORT, {
        emailFromExpert: "",
        shouldVerify: false
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  }
};